import React from 'react';
import { useAppDispatch } from '../app/hooks';
import moment from 'moment';
import lodash from 'lodash';
/* import getThemeLookup from '../selectors/getThemeLookup'; */

import { validateFutureMenuItems } from '../thunks/validateFutureMenuItems';
import TimeSelector from './TimeSelector';
import DateTimeSelectorsWrapper from './DateTimeSelectorsWrapper';

/**
 * # Current date ordering selector
 *
 * @param
 */
const CurrentDateSelector = ({
  time,
  earliestTime,
  latestTime,
  averageOrderWaitTime,
  setTime,
}: {
  time?: string;
  earliestTime?: string | null;
  latestTime?: string | null;
  averageOrderWaitTime: number;
  setTime: (time: string) => void;
}) => {
  const dispatch = useAppDispatch();
  //const p = useAppSelector(getThemeLookup);

  const earliestDateForLocation = moment(earliestTime).toDate();
  const nowWithPadding = moment().add(averageOrderWaitTime, 'minutes').toDate();
  const earliestSelectableDate = lodash.orderBy(
    [earliestDateForLocation, nowWithPadding],
    v => v,
    'desc',
  )[0];

  const latestSelectableDate = moment(latestTime).clone().toDate();

  return (
    <DateTimeSelectorsWrapper>
      <TimeSelector
        value={time}
        setTime={(newTime: string) => {
          if (moment(newTime) > moment(latestSelectableDate)) {
            setTime(moment(latestSelectableDate).toISOString());
          } else {
            setTime(moment(newTime).toISOString());
          }

          dispatch(validateFutureMenuItems());
        }}
        earliestSelectableTime={earliestSelectableDate.toISOString()}
        latestSelectableDate={latestSelectableDate.toISOString()}
        minuteInterval={5}
      />
    </DateTimeSelectorsWrapper>
  );
};

export default CurrentDateSelector;
